/**
 * Checks a fetch Response for 401 status and dispatches the "unauthorized"
 * event so UserContext can redirect to login with a friendly message.
 *
 * Returns true if the response was a 401 (caller should stop processing).
 */
export function handleFetchUnauthorized(response: Response): boolean {
  if (response.status === 401) {
    window.dispatchEvent(new CustomEvent("unauthorized"));
    return true;
  }
  return false;
}
